import mixpanel from "mixpanel-browser"

export interface MixPanelGlobalAuthenticatedProps {
  fullname: string
  email: string
  organization: string
}

export function trackAuthenticatedUsers(props: MixPanelGlobalAuthenticatedProps) {
  mixpanel.register({
    isAuthenticated: true,
    ...props,
  })
}
